import {Notifier} from "@intermesh/goui";
import {ifwLog} from "./IfwLog.js";

export class IfwErrorParser {
	public static parseAndReturn(reason: string) {
		const a = reason.split("||");
		if ( a.length !== 2) {
			// Should not happen, we log the reason in the API
			Notifier.error(reason);
			ifwLog("GouiFrontend", reason);
			return false;
		}
		return JSON.parse(a[1]);
	}
}